import React from 'react';

export const MainGoalDetails = React.lazy(() => import('./pages/MainGoalDetail'));
